import { useState } from 'react';

const inputTagName = 'input';

export const useOpenAccordion = () => {
    const [openAccordionId, setOpenAccordionId] = useState<string | null>(null);

    const handleAccordionChange =
        (accordionId: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
            const tagName = (event.target as HTMLElement).tagName.toLowerCase();
            if (tagName !== inputTagName) {
                setOpenAccordionId(newExpanded ? accordionId : null);
            }
        };

    return { openAccordionId, handleAccordionChange };
};
